/** Ініціали для аватарки-заглушки, напр. "Олександр" + "Кадулін" → "ОК". */
export function getInitials(firstName, lastName) {
  const first = firstName?.[0] || '';
  const last = lastName?.[0] || '';
  return (first + last).toUpperCase();
}
